<template>
  <div>
    <label v-if="labelName">{{ labelName }}:</label>
    <template v-for="opt in options">
      <label class="option" :for="opt.value">
        <input
          type="radio"
          :id="opt.value"
          :value="opt.value"
          @click="selected(opt.value)"
          :checked="isChecked(opt.value)"
          :name="name"
          :disabled="disabled"
        />
        {{ opt.text }}
      </label>
      <div
        v-if="opt.hasOwnProperty('description')"
        class="radio-option-description"
      >
        {{ opt.description }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "RadioSet",
  data() {
    return {
      currentValue: null,
    };
  },
  props: {
    required: Boolean,
    name: String,
    value: [String, Boolean],
    options: Array,
    labelName: String,
    disabled: { type: Boolean, default: false },
  },
  methods: {
    selected(val) {
      this.$emit("radio-selection", val);
    },
    isChecked(optVal) {
      if (this.value === optVal) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.currentValue = this.value;
  },
};
</script>

<style scoped></style>
